const SocialIcon = ({ children }) => {
  return(
    <>
      {children}
    </>
  )
}

export default SocialIcon;